import { Box, Button } from '@mui/material';
import { Alert } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import CustomersAndAnamnesesTab from 'views/customers-anamneses/CustomersAndAnamnesesTab';
import CustomerPageWrapper from '../CustomerPageWrapper';

// COMPONENT
function UnifyCustomerPage() {
  return (
    <CustomersAndAnamnesesTab selectedIndex={0}>
      <CustomerPageWrapper title="Unificar Contatos">
        <div style={{ padding: '20px', marginTop: '10px' }}>
          <Box display="flex" flexDirection="row" justifyContent="space-around">
            <Box display="flex" justifyContent="space-evenly" flexDirection="column" alignItems="center">
              <Button
                component={Link}
                to="/clientes/unificar/automatica"
                color="primary"
                variant="contained"
                style={{ marginBottom: '10px' }}
              >
                Unificação Automática
              </Button>
              <Alert severity="info" icon={false}>
                Aqui o sistema irá sugerir contatos repetidos e você seleciona quais quer unificar.
              </Alert>
            </Box>
            <Box display="flex" justifyContent="space-evenly" flexDirection="column" alignItems="center">
              <Button
                component={Link}
                to="/clientes/unificar/manual"
                color="primary"
                variant="contained"
                style={{ marginLeft: '10px', marginBottom: '10px' }}
              >
                Unificação Manual
              </Button>
              <Alert severity="info" icon={false}>
                Aqui você seleciona manualmente dois ou mais contatos e clica para unificar.
              </Alert>
            </Box>
          </Box>
        </div>
      </CustomerPageWrapper>
    </CustomersAndAnamnesesTab>
  );
}

export default UnifyCustomerPage;
